import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootReducer from './rootReducer'
import { rootSaga } from './rootSaga'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { persistStore } from 'redux-persist'
import { afterRehydrate } from './rehydrate/rehydrateActions'
import StoreService from './StoreService'

function configureStore(preloadedState, { isServer, req = null }) {
  let store
  /**
   * Recreate the stdChannel (saga middleware) with every context.
   */
  let middlewareConfig
  const composeEnhancers = composeWithDevTools({})
  const sagaMiddleware = createSagaMiddleware(middlewareConfig)

  /**
   * Since Next.js does server-side rendering, you are REQUIRED to pass
   * `preloadedState` when creating the store.
   */
  if (isServer) {
    store = createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(sagaMiddleware)))
  } else {
    const { persistReducer } = require('redux-persist')
    const storage = require('redux-persist/lib/storage').default
    const persistConfig = {
      key: 'root',
      storage,
      whitelist: ['auth', 'watch'],
    }
    store = createStore(
      persistReducer(persistConfig, rootReducer),
      preloadedState,
      composeEnhancers(applyMiddleware(sagaMiddleware))
    )
    store.__PERSISTOR = persistStore(store, {}, () => store.dispatch(afterRehydrate()))
  }
  StoreService.setStoreReference(store)

  /**
   * next-redux-saga depends on `sagaTask` being attached to the store during `getInitialProps`.
   * It is used to await the rootSaga task before sending results to the client.
   * However, next-redux-wrapper creates two server-side stores per request:
   * One before `getInitialProps` and one before SSR (see issue #62 for details).
   * On the server side, we run rootSaga during `getInitialProps` only:
   */

  if (req || !isServer) {
    store.sagaTask = sagaMiddleware.run(rootSaga)
  }

  return store
}

export default configureStore
